// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

const PREVIEW_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PREVIEW_ROUTE}`;

import AuthApi from '@/store/api/system/auth';

import NumberOfPendingArticleReservationsGql from '@/extensions/shop/pointOfSale/store/graphql/queries/NumberOfPendingArticleReservations.gql';
import PendingReservationPurchasesGql from '@/extensions/shop/pointOfSale/store/graphql/queries/PendingReservationPurchases.gql';
import NumberOfPendingArticleShippingsGql from '@/extensions/shop/pointOfSale/store/graphql/queries/NumberOfPendingArticleShippings.gql';
import PendingShippingPurchasesGql from '@/extensions/shop/pointOfSale/store/graphql/queries/PendingShippingPurchases.gql';
import PendingShippingPurchaseGql from '@/extensions/shop/pointOfSale/store/graphql/queries/PendingShippingPurchase.gql';

import MarkPurchasedItemAsReservedGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/MarkPurchasedItemAsReserved.gql'
import UnmarkPurchasedItemAsReservedGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/UnmarkPurchasedItemAsReserved.gql'

import MarkPurchasedItemAsMissingGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/MarkPurchasedItemAsMissing.gql'
import UnmarkPurchasedItemAsMissingGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/UnmarkPurchasedItemAsMissing.gql'

import SellGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/Sell.gql'
import SellLaterGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/SellLater.gql'
import RequestArticlesGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/RequestArticles.gql'

import { parseInt } from 'lodash';

export default {
    fetchNumberOfPendingArticleReservations: (pointOfSaleID = null, stockID = null, cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (pointOfSaleID) variables.pointOfSale = parseInt(pointOfSaleID);
            if (stockID) variables.stock = parseInt(stockID);
            // Multistore: count the same queue the list shows.
            if (cmsID) variables.cms = parseInt(cmsID);
            apolloClient
                .query({
                    query: NumberOfPendingArticleReservationsGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.EX_POS_NumberOfPendingArticleReservations))
                .catch((err) => reject(err));
        }),
    fetchPendingReservationPurchases: (pointOfSaleID = null, stockID = null, skip = 0, take = 10, cmsID = null) =>
        new Promise((resolve, reject) => {

            let variables = {};
            if (pointOfSaleID) variables.pointOfSale = parseInt(pointOfSaleID);
            if (stockID) variables.stock = parseInt(stockID);
            // Multistore: count the same queue the list shows.
            if (cmsID) variables.cms = parseInt(cmsID);
            if (skip) variables.skip = parseInt(skip);
            if (take) variables.take = parseInt(take);

            apolloClient
                .query({
                    query: PendingReservationPurchasesGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => {
                    var count = 0;
                    data.EX_POS_PendingReservationPurchases.forEach(element => {
                        count += element.items.length
                    });
                    resolve(data.EX_POS_PendingReservationPurchases)
                })

                .catch((err) => reject(err));
        }),
    fetchNumberOfPendingArticleShippings: (pointOfSaleID = null, stockID = null, cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (pointOfSaleID) variables.pointOfSale = parseInt(pointOfSaleID);
            if (stockID) variables.stock = parseInt(stockID);
            // Multistore: count the same queue the list shows.
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: NumberOfPendingArticleShippingsGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.EX_POS_NumberOfPendingArticleShippings))
                .catch((err) => reject(err));
        }),
    fetchPendingShippingPurchases: (pointOfSaleID = null, stockID = null, skip = 0, take = 10, cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (pointOfSaleID) variables.pointOfSale = parseInt(pointOfSaleID);
            if (stockID) {
                variables.stock = parseInt(stockID);
            }
            if (skip) variables.skip = parseInt(skip);
            if (take) variables.take = parseInt(take);
            // Multistore: the queue belongs to the selected store, even though the
            // stock behind it is shared.
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: PendingShippingPurchasesGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.EX_POS_PendingShippingPurchases))
                .catch((err) => reject(err));
        }),
    fetchPendingShippingPurchase: (id, pointOfSaleID, stock) =>
        new Promise((resolve, reject) => {
            let variables = {
                id: parseInt(id),
                stock: parseInt(stock),
                pointOfSale: parseInt(pointOfSaleID),
            };

            apolloClient
                .query({
                    query: PendingShippingPurchaseGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.EX_POS_PendingShippingPurchase))
                .catch((err) => reject(err));
        }),

    markPurchasedItemAsReserved: (item, stock, pointOfSale, pivotID) => {
        if (item === undefined
            || stock === undefined
            || pointOfSale === undefined
            || pivotID === undefined
        ) {
            throw new Error('required argument is missing')
        }

        item = _.removeDeepByKey(item, '__typename')
        stock = _.removeDeepByKey(stock, '__typename')
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')

        if (stock.pivot !== undefined) delete stock.pivot

        if (item.loading !== undefined) delete item.loading
        if (item.reserving !== undefined) delete item.reserving
        if (item.unreserving !== undefined) delete item.unreserving
        if (item.missing !== undefined) delete item.missing
        if (item.unmissing !== undefined) delete item.unmissing

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: MarkPurchasedItemAsReservedGql,
                variables: {
                    item,
                    stock,
                    pointOfSale,
                    pivotID
                }
            })
                .then(({ data }) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_MarkPurchasedItemAsReserved)
                })
                .catch(err => reject(err))
        })
    },

    unmarkPurchasedItemAsReserved: (item, stock, pointOfSale, pivotID) => {
        if (item === undefined
            || stock === undefined
            || pointOfSale === undefined
            || pivotID === undefined
        ) {
            throw new Error('required argument is missing')
        }

        item = _.removeDeepByKey(item, '__typename')
        stock = _.removeDeepByKey(stock, '__typename')
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')

        if (stock.pivot !== undefined) delete stock.pivot

        if (item.loading !== undefined) delete item.loading
        if (item.reserving !== undefined) delete item.reserving
        if (item.unreserving !== undefined) delete item.unreserving
        if (item.missing !== undefined) delete item.missing
        if (item.unmissing !== undefined) delete item.unmissing

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UnmarkPurchasedItemAsReservedGql,
                variables: {
                    item,
                    stock,
                    pointOfSale,
                    pivotID
                }
            })
                .then(({ data }) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_UnmarkPurchasedItemAsReserved)
                })
                .catch(err => reject(err))
        })
    },

    markPurchasedItemAsMissing: (item, stock, pointOfSale, pivotID) => {
        if (item === undefined
            || stock === undefined
            || pointOfSale === undefined
            || pivotID === undefined
        ) {
            throw new Error('required argument is missing')
        }

        item = _.removeDeepByKey(item, '__typename')
        stock = _.removeDeepByKey(stock, '__typename')
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')

        let qtyLimit = 0
        if (stock.pivot !== undefined) {
            if (stock.pivot.qty_limit) qtyLimit = stock.pivot.qty_limit
            delete stock.pivot
        }

        if (item.loading !== undefined) delete item.loading
        if (item.reserving !== undefined) delete item.reserving
        if (item.unreserving !== undefined) delete item.unreserving
        if (item.missing !== undefined) delete item.missing
        if (item.unmissing !== undefined) delete item.unmissing

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: MarkPurchasedItemAsMissingGql,
                variables: {
                    item,
                    stock,
                    pointOfSale,
                    pivotID,
                    qtyLimit
                }
            })
                .then(({ data }) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_MarkPurchasedItemAsMissing)
                })
                .catch(err => reject(err))
        })
    },

    unmarkPurchasedItemAsMissing: (item, stock, pointOfSale, pivotID) => {
        if (item === undefined
            || stock === undefined
            || pointOfSale === undefined
            || pivotID === undefined
        ) {
            throw new Error('required argument is missing')
        }

        item = _.removeDeepByKey(item, '__typename')
        stock = _.removeDeepByKey(stock, '__typename')
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')

        if (stock.pivot !== undefined) delete stock.pivot

        if (item.loading !== undefined) delete item.loading
        if (item.reserving !== undefined) delete item.reserving
        if (item.unreserving !== undefined) delete item.unreserving
        if (item.missing !== undefined) delete item.missing
        if (item.unmissing !== undefined) delete item.unmissing

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UnmarkPurchasedItemAsMissingGql,
                variables: {
                    item,
                    stock,
                    pointOfSale,
                    pivotID
                }
            })
                .then(({ data }) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_UnmarkPurchasedItemAsMissing)
                })
                .catch(err => reject(err))
        })
    },

    sell: (purchase, pointOfSale, split, returnRemainingCouponAmountAsCash = false) => {
        purchase = _.removeDeepByKey(purchase, '__typename');
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename');

        let variables = {
            purchase,
            pointOfSale,
            returnRemainingCouponAmountAsCash,
        }

        if (split) {
            variables.split = _.removeDeepByKey(split, '__typename');
        }

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: SellGql,
                variables,
                // fetchPolicy: 'no-cache'
            })
                .then(async ({ data }) => {
                    // apolloClient.clearStore()
                    await apolloClient.clearStore();
                    resolve(data.EX_POS_Sell)
                })
                .catch(err => reject(err))
        })
    },
    sellLater: (purchase, pointOfSale) => {
        purchase = _.removeDeepByKey(purchase, '__typename');
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename');

        let variables = {
            purchase,
            pointOfSale,
        }

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: SellLaterGql,
                variables,
                // fetchPolicy: 'no-cache'
            })
                .then(async ({ data }) => {
                    // WARN: clear store results in an error
                    // // apolloClient.clearStore()
                    // await new Promise(resolve => setTimeout(resolve, 300));
                    // await apolloClient.clearStore();
                    // // await new Promise(resolve => setTimeout(resolve, 300));
                    resolve(data.EX_POS_SellLater)
                })
                .catch(err => reject(err))
        })
    },
    requestArticles: (purchase, pointOfSale) => {
        purchase = _.removeDeepByKey(purchase, '__typename');
        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: RequestArticlesGql,
                variables: {
                    purchase,
                    pointOfSale
                }
            })
                .then(({ data }) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_RequestArticles)
                })
                .catch(err => reject(err))
        })
    }
};
